import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { FileDropZone } from './FileDropZone';
import { useStores } from '../../stores/Hooks';
import { FileDropZoneUploadingItem } from './FileDropZoneUploadingItem';
import { DeleteFormCallbackEnum, ModalTypeEnum } from '../../stores/libraries/ModalLibrary';
import { StatementStatusEnum } from '../../models';

interface IFileDropZoneUploaderList
{
	/** Текст внутри кнопки */
	ButtonText?: string,

	/** Текст рядом с кнопкой */
	DescriptionText?: string,

	/** Текст рядом с кнопкой мелким шрифтом */
	TipText?: string,

	/** Разрешенные для дропания типы файлов */
	Accept?: string,

	/** Комментарий */
	Comment?: string,

	/** Идентификатор типа файлов, который привязан к текущему списку загружаемых файлов */
	FileTypeId: string,

	/** Разрешенные расширения файлов */
	AllowedExtensions: string[]
}

export const FileDropZoneUploaderList: React.FC<IFileDropZoneUploaderList> = observer(
	(
		{
			ButtonText = "Выберите файлы",
			DescriptionText = "Перетащите сюда файл (файлы) для загрузки",
			TipText = "",
			Accept = "",
			Comment = "",
			FileTypeId,
			AllowedExtensions
		}: IFileDropZoneUploaderList
	) =>
	{
		const { uiState } = useStores();
		const store = uiState.files;

		const fileArray = store.FileLists!.get(FileTypeId);

		const FileDropZoneOnDrop = (acceptedFiles: File[]) =>
		{
			if (!fileArray) return;

			for (let i = 0; i < acceptedFiles.length; i++)
			{
				let f: File = acceptedFiles[i];

				let ext: string | undefined = "";
				if (f.name)
				{
					let sp: string[] = f.name.split('.');
					if (sp.length > 1) ext = sp.pop()?.toLowerCase();
				}
				if (!ext) continue;
				if (AllowedExtensions.indexOf(ext) < 0)
				{
					uiState.modal.setShowModal(true, ModalTypeEnum.Error, "Ошибка добавления файлов", "Разрешено добавлять файлы только следующих типов: " + AllowedExtensions.join(", "));
					return;
				}
				if (f.size + store.CurrentStorageSize >= store.MaxStorageSize)
				{
					uiState.modal.setShowModal(true, ModalTypeEnum.Error, "Ошибка добавления файлов", "Превышен допустимый объем файлов (не более 70 Мб)");
					return;
				}


				// если форма была уже создана
				if (uiState.StatementStatus !== StatementStatusEnum.NotCreated)
				{
					uiState.modal.SetChangeFormAction(DeleteFormCallbackEnum.AddingFile);
					uiState.modal.SetAddingFile(f);
					uiState.modal.SetAddingFileType(FileTypeId);
					uiState.modal.setShowModal(true, ModalTypeEnum.DeleteFormRequired, "Данные изменились", "Вы уверены, что хотите изменить данные?<br />Сформированное ранее заявление будет удалено из раздела “Заявление оператора ЭДО”.");
					return;
				}

				// Добавляем файл
				store.AddFileLibrary(FileTypeId, f);
			}
		}

		return (
			<div className="accordion-content">
				<p className="mb-4">{uiState.modal.ParseBR(Comment)}</p>
				{!uiState.IsDisabled &&
					<FileDropZone Disabled={uiState.IsDisabled} ButtonText={ButtonText} DescriptionText={DescriptionText} TipText={TipText} Accept={Accept} OnDropAction={FileDropZoneOnDrop} />
				}
				<div className="file-cards">
					{
						fileArray && fileArray.map(el => (<FileDropZoneUploadingItem key={el.FileId} FileId={el.FileId} FileTypeId={FileTypeId} />))
					}
				</div>
			</div>

		)
	}
)